<template>
  <div style="margin: 0 auo">
    <div style="color: #3d4d6b">
      <ul class="invite-content invite-content-shop">
        <li style="text-align: center; padding: 15px">
          {{ $t('component.ShopM.chooseShop') }}
        </li>
        <!-- style="display: flex; align-items: center;justify-content: space-around" chooseBox-->
        <li class="chooseBox">
          <!-- style="border: 0; width: 48%" -->
          <a-input
            v-model:value="siteNameInput"
            @click="showStationorMall"
            :placeholder="$t('component.SiteM.chooseLocation')"
            readOnly
          ></a-input>
          <!-- style="border: 0; width: 48%" -->
          <a-input
            v-model:value="shopNameInput"
            @click="showShopc"
            :placeholder="$t('component.ShopM.chooseShop')"
            readOnly
          >
          </a-input>
        </li>
        <!-- style="text-align: center; padding: 15px" emailTitleBox-->
        <li class="emailTitleBox">
          {{ $t('invitePage.inputInviteTargetEmail') }}
        </li>
        <!-- style="display: flex; align-items: center; justify-content: center" emailInputBox -->
        <li class="emailInputBox">
          <!-- style="border: 0; width: 98%" -->
          <a-input
            v-model:value="userEmailInput"
            :placeholder="$t('invitePage.inputInviteTargetEmail')"
          >
          </a-input>
        </li>
        <!-- userNameBox style=" display: flex; align-items: center;justify-content: space-around; margin-top: 9px;" -->
        <li class="userNameBox">
          <!-- style="border: 0; width: 48%" -->
          <a-input
            v-model:value="userFirstName"
            :placeholder="$t('invitePage.firstName')"
          ></a-input>
          <!-- style="border: 0; width: 48%" -->
          <a-input
            v-model:value="userLastName"
            :placeholder="$t('invitePage.lastName')"
          ></a-input>
        </li>
        <!-- style="  display: flex; align-items: center; justify-content: center; margin-top: 9px;"faxInputBox -->
        <li class="faxInputBox">
          <!--  style="display: flex; align-items: center; justify-content: center" -->
          <div class="faxInutDivBox">
            <!-- countryCodeSelect style="width: 71px; margin-right: 5px; font-size: 12px" -->
            <a-select
              class="countryCodeSelect"
              v-model:value="faxCountryCode"
              default-value="+852"
            >
              <a-select-option v-for="item in CountryCodeList" :key="item.code"
                >{{ item.code }}
              </a-select-option></a-select
            >
            <!--faxInput style="border: 0; width: 56%" -->
            <a-input
              class="faxInput"
              v-model:value="fax"
              :placeholder="$t('invitePage.fax')"
            ></a-input>
          </div>
          <!-- style="display: flex; align-items: center; justify-content: center" -->
          <div class="faxInutDivBox">
            <!-- style="width: 71px; margin-right: 5px; font-size: 12px"         -->
            <a-select
              v-model:value="phoneCountryCode"
              default-value="+852"
              class="countryCodeSelect"
            >
              <a-select-option
                v-for="item in CountryCodeList"
                :key="item.code"
                >{{ item.code }}</a-select-option
              ></a-select
            >
            <!-- style="border: 0; width: 56%" -->
            <a-input
              class="faxInput"
              v-model:value="phoneNumber"
              :placeholder="$t('invitePage.phone')"
            ></a-input>
          </div>
        </li>
        <!-- .mobileBox style="display: flex;align-items: center; margin-top: 9px; margin-left: 5px; " -->
        <li class="mobileBox">
          <!-- style="width: 71px; margin-right: 5px; font-size: 12px" -->
          <a-select
            v-model:value="mobileCountryCode"
            default-value="+852"
            class="countryCodeSelect"
          >
            <a-select-option v-for="item in CountryCodeList" :key="item.code"
              >{{ item.code }}
            </a-select-option>
          </a-select>
          <!-- style="border: 0; width: 28%" -->
          <a-input
            v-model:value="mobileNumber"
            :placeholder="$t('invitePage.mobile')"
            class="faxInput"
          ></a-input>
        </li>
      </ul>
    </div>
    <div style="text-align: center; padding-top: 10px">
      {{ $t('invitePage.restInvitationQuota') }}{{ InvitationQuota }}
    </div>
    <div style="text-align: center; padding-top: 20px">
      <a-button
        :loading="loading"
        @click="invite"
        type="primary"
        style="height: 38px; background: #2ca70e; border-color: #2ca70e"
        >{{ $t('invitePage.invite') }}</a-button
      >
    </div>
    <station-m
      ref="stationm"
      isSingleChoose="1"
      @chooseSiteConfirm="chooseSiteConfirm"
    ></station-m>
    <shop-c
      ref="shopc"
      isSingleChoose="1"
      @chooseShopConfirm="chooseShopConfirm"
    ></shop-c>
  </div>
</template>


<script>
import StationM from './StationOrMallChoose';
import ShopC from './ShopChoose';
export default {
  name: 'InviteShop',
  data() {
    return {
      siteNameInput: '',
      shopNameInput: '',
      userFirstName: '',
      userLastName: '',
      userEmailInput: '',
      shopobj: '',
      InvitationQuota: '',
      loading: false,
      CountryCodeList: '',
      faxCountryCode: '+852',
      fax: '',
      mobileCountryCode: '+852',
      mobileNumber: '',
      phoneCountryCode: '+852',
      phoneNumber: ''
    };
  },
  components: { StationM, ShopC },
  methods: {
    showShopc() {
      this.$refs.shopc.visible = true;
    },
    showStationorMall() {
      this.$refs.stationm.visible = true;
    },
    chooseSiteConfirm(s) {
      this.siteNameInput = s[0].name;
    },
    chooseShopConfirm(s) {
      this.shopNameInput = s[0].name;
      this.shopobj = s[0];
    },
    invite() {
      this.$emit('invite', {
        name: 'InviteShop',
        email: this.userEmailInput,
        firstName: this.userFirstName,
        lastName: this.userLastName,
        targetShop: this.shopobj,
        faxCountryCode: this.faxCountryCode,
        fax: this.fax,
        mobileCountryCode: this.mobileCountryCode,
        mobileNumber: this.mobileNumber,
        phoneCountryCode: this.phoneCountryCode,
        phoneNumber: this.phoneNumber
      });
    }
  },
  mounted() {
    this.$refs.stationm.ShopM = this.$refs.shopc;
    this.$refs.shopc.resetSites([]);
  },
  created() {
    let t1 = this.$store.getters.get_CountryCode_cache;
    this.CountryCodeList = t1;
  }
};
</script>

<style scoped>
.invite-content {
  background-color: #c6cbd1;
  min-height: 350px;
  display: flex;
  flex-flow: column;
}
.invite-content-shop {
  border-radius: 8px 0px 8px 8px;
}
input::-ms-input-placeholder {
  text-align: center;
}
input::-webkit-input-placeholder {
  text-align: center;
}
.chooseBox {
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.chooseBox input {
  border: 0px;
  width: 48%;
}
.emailTitleBox {
  text-align: center;
  padding: 15px;
}
.emailInputBox {
  display: flex;
  align-items: center;
  justify-content: center;
}
.emailInputBox > input {
  border: 0;
  width: 98%;
}
.userNameBox {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-top: 9px;
}
.userNameBox > input {
  border: 0;
  width: 48%;
}
.faxInputBox {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 9px;
}

.faxInutDivBox {
  display: flex;
  align-items: center;
  justify-content: center;
}

.countryCodeSelect {
  width: 71px;
  margin-right: 5px;
  font-size: 12px;
}
.faxInput {
  border: 0;
  width: 56%;
}
.mobileBox {
  display: flex;
  align-items: center;
  margin-top: 9px;
  margin-left: 5px;
}

@media (max-width: 420px) {
  .chooseBox {
    flex-direction: column;
  }
  .chooseBox input {
    width: 97%;
    margin-bottom: 5px;
  }
  .emailTitleBox {
    text-align: center;
    padding: 5px;
    margin-bottom: 5px;
  }
  .emailInputBox {
    flex-direction: column;
  }
  .emailInputBox > input {
    width: 97%;
  }
  .userNameBox {
    flex-direction: column;
    margin-top: 5px;
  }
  .userNameBox > input {
    width: 97%;
    margin-bottom: 5px;
  }
  .faxInputBox {
    margin-top: 0px;
    flex-direction: column;
    margin-top: 2px;
  }

  .faxInutDivBox {
    width: 97%;
    margin-bottom: 5px;
  }
  .countryCodeSelect {
    width: 30%;
  }
  .faxInput {
    width: 68%;
  }
  .mobileBox {
    width: 97%;
    margin-top: 0px;
    margin-bottom: 20px;
  }
}
</style>
